import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'num', pure: false})
export class NumPipe implements PipeTransform {
  transform(value: string|number): string {
    if (typeof value === 'string') {
      return parseFloat(value.replace(/,/g, '')).toLocaleString('en-US');
    } else if (typeof value === 'number') {
      return value.toLocaleString('en-US')
    }
    return ''
  }
}
